import { Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { Language } from '../../model/languages';
import { CommonModule } from '@angular/common';
import { HeaderService } from './header.service';
import { StorageService } from '../../core/storage.service';
import { AuthService } from '../../core/auth/auth.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterLink, CommonModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent {
  constructor(
    private headerService: HeaderService,
    private router: Router,
    private storageService: StorageService,
    private authService: AuthService,
  ) {}

  languages: Language[] = [];
  selectedLanguage: Language | undefined;
  clinics: { id: number; name: string }[] = [];
  selectedClinicId: number | null = null;
  get isTherapist(): boolean { return this.authService.isTherapist(); }

  ngOnInit() {
    this.getLanguages();
    if (this.authService.isTherapist()) {
      this.clinics = this.authService.getClinics();
      const selected = this.authService.getSelectedClinic();
      this.selectedClinicId = selected?.id ?? (this.clinics[0]?.id ?? null);
    }
  }

  getLanguages() {
    this.headerService.getLanguages().subscribe((lang) => {
      this.languages = lang;

      var languageId = this.storageService.getItem('languageId');

      if (languageId && languageId !== '0') {
        const selectedLanguage = this.languages.find(
          (lang) => lang.id === parseInt(languageId!),
        );
        if (selectedLanguage) {
          this.selectedLanguage = selectedLanguage;
        }
      } else {
        const defaultLanguage = this.languages.find((lang) => lang.isDefault);
        this.selectedLanguage = defaultLanguage || this.languages[0];
        this.storageService.setItem('languageId', this.selectedLanguage.id.toString());
      }

      this.languages.forEach((lang) => {
        lang.flagTag = lang.flagTag.replace('flag-xs', 'flag-sm');
      });
    });
  }

  setLanguage(languageId: number) {
    this.headerService.setLanguage(languageId).subscribe((response) => {
      if (response) {
        this.router.navigate(['/']);
      }
    });
  }

  onLanguageChange(language: any) {
    this.selectedLanguage = language;
    this.setLanguage(language.id);
  }

  onClinicChange(event: Event): void {
    const id = Number((event.target as HTMLSelectElement).value);
    const clinic = this.clinics.find(c => c.id === id);
    if (clinic) {
      this.selectedClinicId = clinic.id;
      this.authService.setSelectedClinic(clinic.id, clinic.name);
    }
  }

  logout() {
    this.router.navigate(['/logout']);
  }
}
